export default __webpack_public_path__ + "static/media/player.4e54fcfb.png";